import axios from '@axios'

export const state = {
	groups: [],
	currentPage: 1,
	perPage: 15,
	totalPages: 1,
	totalRecords: 0,
}

export const mutations = {
	GET_GROUPS: (state, group) => {
		state.groups = group.allGroups
		state.groups = group.userGroups
		state.currentPage = group.page
		state.perPage = group.perPage
		state.totalPages = group.totalPages
		state.totalRecords = group.totalRecords
	},

	UPDATE_GROUP: (state, group) => {
		for (let i = 0; i < state.groups.length; i++) {
			if (state.groups[i].id === group.id) {
				for (let field in group) {
					state.groups[i][field] = group[field]
				}
				break
			}
		}
	},

	TOGGLE_GROUP: (state, group) => {
		for (let i = 0; i < state.groups.length; i++) {
			if (state.groups[i].id === group.id) {
				state.groups[i].active = group.active
				break
			}
		}
	},

	CREATE_GROUP: (state, groups) => {
		state.groups.unshift(groups)
	},

	REMOVE_GROUP: (state, data) => {
		let groups = state.groups.filter((group) => {
			return group.id !== data.id
		})
		state.groups = groups
	},
}

export const getters = {
	allGroups: (state) => state.groups,
	currentPage: (state) => state.currentPage,
	perPage: state => state.perPage,
	totalPages: (state) => state.totalPages,
	totalRecords: (state) => state.totalRecords,
}
export const actions = {
	async getGroups({ commit }, paginate = {}) {
		await axios
			.get(`/users/group`, { params: paginate })
			.then((resp) => {
				if (resp.status === 200) {
					commit('GET_GROUPS', resp.data)
				}
			})
			.catch(() => {
				commit('GET_GROUPS', {})
			})
	},
	async getGroup({ commit }, group) {
		return axios.get(`/users/group/${group.id}`)
	},
	async createGroup({ commit }, group) {
		await axios.post(`/users/group`, group)
			.then((resp) => {
				if (resp.status === 201) {
					commit('CREATE_GROUP', resp.data)
				}
			})
	},
	async updateGroup({ commit }, group) {
		await axios.put(`/users/group`, group)
			.then(resp => {
				if (resp.status === 200) {
					commit('UPDATE_GROUP', resp.data)

				}
			})
	},
	async toggleGroup({ commit }, group) {
		await axios
			.patch(`/users/group/${group.id}`)
			.then((resp) => {
				if (resp.status === 200) {
					commit('TOGGLE_GROUP', resp.data)
				}
			})
	},
	async removeGroup({ commit }, group) {
		await axios.delete(`/users/group/${group.id}`)
			.then((resp) => {
				if (resp.status === 204) {
					commit('REMOVE_GROUP', group)
				}
			})
	},
}
